import React from 'react';

import CommonHeader from './CommonHeader';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, children, isLoading = false }) => {

  
  return (
    <div className="h-dvh bg-black">
      <CommonHeader
        title={title}
      />
      
      {/* Page content */}
      <main className="max-w-3xl mx-auto p-6 text-white" style={{ paddingTop: '55px' }}>
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
          </div>
        ) : (
          children
        )}
      </main>
    </div>
  );
};

export default LegalPageLayout; 